import FullPage from './FullPage';
import { DeliveryProvider } from './Providers/index';

export default FullPage;
export { DeliveryProvider };
